import { jsx } from "react/jsx-runtime";
import "react";
import PropTypes from "prop-types";
import { Group, CustomPropTypes } from "@zillow/zrs-cms";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const BlockGroup = ({
  attrs,
  innerBlocks
}) => {
  const {
    alignItems = {
      default: "stretch"
    },
    backgroundImage,
    backgroundImageVisible = {
      default: true,
      lg_lte: true,
      sm_lte: true
    },
    backgroundPosition,
    backgroundSize,
    borderRadius,
    justifyContent = {
      default: "center"
    },
    loading = "lazy",
    margin = {
      marginBottom: {
        default: "lg",
        lg_lte: "md",
        sm_lte: "sm"
      }
    },
    maxWidth = {
      default: "xl"
    },
    padding = {
      paddingTop: {
        default: "lg",
        lg_lte: "md",
        sm_lte: "sm"
      },
      paddingBottom: {
        default: "lg",
        lg_lte: "md",
        sm_lte: "sm"
      },
      paddingRight: {
        default: "lg",
        lg_lte: "md",
        sm_lte: "sm"
      },
      paddingLeft: {
        default: "lg",
        lg_lte: "md",
        sm_lte: "sm"
      }
    },
    ...groupProps
  } = attrs;
  return /* @__PURE__ */ jsx(Group, { alignItems, backgroundImage, backgroundImageVisible, backgroundPosition, backgroundSize, justifyContent, loading, maxWidth, ...borderRadius, ...groupProps, ...margin, ...padding, children: generateBlockList({
    blocks: innerBlocks
  }) });
};
BlockGroup.propTypes = {
  attrs: PropTypes.shape({
    alignItems: CustomPropTypes.inlineMediaQuery(PropTypes.string),
    backgroundImage: CustomPropTypes.inlineMediaQuery(PropTypes.shape({})),
    backgroundPosition: CustomPropTypes.inlineMediaQuery(PropTypes.string),
    justifyContent: CustomPropTypes.inlineMediaQuery(PropTypes.string),
    maxWidth: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", "full"])),
    padding: CustomPropTypes.inlineMediaQuery(PropTypes.shape({
      paddingTop: PropTypes.string,
      paddingRight: PropTypes.string,
      paddingLeft: PropTypes.string,
      paddintBottom: PropTypes.string
    })),
    margin: CustomPropTypes.inlineMediaQuery(PropTypes.shape({
      marginTop: PropTypes.string,
      marginBottom: PropTypes.string
    })),
    borderRadius: CustomPropTypes.inlineMediaQuery(PropTypes.shape({
      borderRadiusTopLeft: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
      borderRadiusTopRight: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
      borderRadiusBottomLeft: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
      borderRadiusBottomRight: PropTypes.oneOf([PropTypes.string, PropTypes.number])
    })),
    loading: PropTypes.string
  }),
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
};
export {
  BlockGroup as default
};
